import Vue from 'vue';
import api from '../bu/api';

export default {
    namespaced: true,

    state: () => ({
        pricingRules: [],
        editingRule: null
    }),

    getters: {
        pricingRules(state) {
            return state.pricingRules;
        },
        editingRule(state) {
            return state.editingRule;
        }
    },

    actions: {
        async fetchPricingRules({ commit }, {entityType, entityId}) {
            commit('setPricingRules', []);
            const response = await api.getPricingRules(entityType, entityId);
            commit('setPricingRules', response.data);
        },
        async savePricingRule({commit}, {rule, entityType, entityId}) {
            const response = await api.savePricingRule(rule, entityType, entityId);
            commit('updateRule', response.data);
        },
        setEditingRule({commit}, rule) {
            commit('setEditingRule', Object.assign({}, rule));
        },
        createNewRule({commit}) {
            commit('setEditingRule', {
                period_start: null,
                period_end: null,
                weekdays: null
            });
        },
        resetEditingRule({commit}) {
            commit('setEditingRule', null);
        },
        async deleteRule({commit}, rule) {
            try {
                await api.deletePricingRule(rule);
                commit('deleteRule', rule);
            } catch {}
        }
    },

    mutations: {
        setPricingRules(state, rules) {
            Vue.set(state, 'pricingRules', rules);
        },
        setEditingRule(state, rule) {
            Vue.set(state, 'editingRule', rule);
        },
        updateRule(state, rule) {
            const existingIndex = state.pricingRules.findIndex((r) => r.id == rule.id);
            if (existingIndex >= 0) {
                state.pricingRules[existingIndex] = rule;
            }
        },
        deleteRule(state, rule) {
            state.pricingRules = state.pricingRules.filter((r) => r.id != rule.id);
        }
    },
}